import { User } from "./user";

export class Device {

    id: number;
    date_create: string;
    firebase_token: string;
    date_last_visit: string;
    browser: string;
    browser_version: string;
    os: string;
    os_version: string;
    type: string;
    lang: string;
    country_code: string;
    country_name: string;
    latitude: number;
    longitude: number;
    city: string;
    ipv4: string;
    user: User;




}
